module.exports = __webpack_public_path__ + "static/media/menu_background.06c693a1.jpg";